import { fetchCurrentUser } from '../../ducks/user.duck';
import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const FETCH_LISTINGS_REQUEST = 'app/ContactPage/FETCH_LISTINGS_REQUEST';
export const FETCH_LISTINGS_SUCCESS = 'app/ContactPage/FETCH_LISTINGS_SUCCESS';
export const FETCH_LISTINGS_ERROR = 'app/ContactPage/FETCH_LISTINGS_ERROR';

// ================ Reducer ================ //

const initialState = {
  // Lightweight listing summaries for the "which listing" picker:
  // { id, title, state, listingStatus, listingNumber }
  ownListings: [],
  queryListingsInProgress: false,
  queryListingsError: null,
};

export default function contactPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LISTINGS_REQUEST:
      return { ...state, queryListingsInProgress: true, queryListingsError: null };
    case FETCH_LISTINGS_SUCCESS:
      return { ...state, queryListingsInProgress: false, ownListings: payload };
    case FETCH_LISTINGS_ERROR:
      // Non-fatal: the picker simply doesn't render. Don't block the page.
      return { ...state, queryListingsInProgress: false, queryListingsError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchListingsRequest = () => ({ type: FETCH_LISTINGS_REQUEST });
export const fetchListingsSuccess = listings => ({
  type: FETCH_LISTINGS_SUCCESS,
  payload: listings,
});
export const fetchListingsError = e => ({
  type: FETCH_LISTINGS_ERROR,
  payload: e,
  error: true,
});

// ================ Thunks ================ //

// Map an own-listing resource to the minimal summary the picker needs.
const toSummary = l => ({
  id: l.id?.uuid,
  title: l.attributes?.title,
  state: l.attributes?.state,
  listingStatus: l.attributes?.publicData?.listingStatus || null,
  // Human-friendly Rails listing number (migration-backfilled). May be absent
  // on listings created natively / not yet backfilled — the picker falls back
  // to the title alone in that case.
  listingNumber: l.attributes?.publicData?.legacyListingNumber || null,
});

export const queryOwnListings = () => (dispatch, getState, sdk) => {
  dispatch(fetchListingsRequest());

  // SORT GOTCHA (TPH §20.1): on this marketplace sort:'createdAt' returns
  // NEWEST-first. Include ALL states (draft / pendingApproval / published /
  // closed) — the picker is "any listing you've ever had", newest first.
  return sdk.ownListings
    .query({
      sort: 'createdAt',
      perPage: 100,
      'fields.listing': ['title', 'state', 'publicData'],
    })
    .then(response => {
      const listings = (response?.data?.data || []).map(toSummary);
      dispatch(fetchListingsSuccess(listings));
      return listings;
    })
    .catch(e => {
      dispatch(fetchListingsError(storableError(e)));
      // Swallow — the contact form still works without the picker.
    });
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  // The picker only renders for an authenticated user with >=1 listing, so we
  // need the current user first; then fetch their listings if signed in.
  return dispatch(fetchCurrentUser()).then(() => {
    const { currentUser } = getState().user;
    if (currentUser?.id) {
      return dispatch(queryOwnListings());
    }
    return Promise.resolve();
  });
};
